import { render, staticRenderFns } from "./RegattaInfo.vue?vue&type=template&id=46183f1d&"
import script from "./RegattaInfo.vue?vue&type=script&lang=js&"
export * from "./RegattaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports